
<b-container class="no-gutters">
  <b-row align-h="center">
    <b-col v-if="interactive" align="center">
      <template v-if="schedule.length > 0">
        <p>(Tap to see our hours)</p>
        <b-collapse id="collapse" class="mt-2">
          <b-card>
            <table cellpadding="6" class="hours">
              <tr v-for="(day, index) in formattedSchedule" :key="index">
                <td class="align-top" style="padding: 0;">
                  <b>{{ day.name }}&nbsp;&nbsp;&nbsp;</b>
                </td>
                <td style="padding:0;padding-bottom: 0.15rem;font-size:0.95em;">
                  <template v-for="(timeRange, timeIndex) in day.timeRanges">
                    <template v-if="timeIndex > 0">
                      <br>
                    </template>
                    {{ timeRange }}
                  </template>
                </td>
              </tr>
            </table>
          </b-card>
        </b-collapse>
      </template>
    </b-col>
    <div v-else>
      <table cellpadding="6" class="hours">
        <tr v-for="(day, index) in formattedSchedule" :key="index">
          <td class="align-top" style="padding: 0;">
            <b>{{ day.name }}&nbsp;&nbsp;&nbsp;</b>
          </td>
          <td style="padding:0;padding-bottom: 0.15rem;font-size:0.95em;">
            <template v-for="(timeRange, timeIndex) in day.timeRanges">
              <template v-if="timeIndex > 0">
                <br>
              </template>
              {{ timeRange }}
            </template>
          </td>
        </tr>
      </table>
    </div>
  </b-row>
</b-container>
